var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9580_70665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.25C12.6554 2.25 10.686 2.374 9.06259 2.73478C7.42502 3.09871 6.06395 3.72 5.01697 4.76697C3.97 5.81395 3.34871 7.17502 2.98478 8.81259C2.624 10.436 2.5 12.4054 2.5 14.75C2.5 17.0946 2.624 19.064 2.98478 20.6874C3.34871 22.325 3.97 23.686 5.01697 24.733C6.06395 25.78 7.42502 26.4013 9.06259 26.7653C10.686 27.126 12.6554 27.25 15 27.25C17.3446 27.25 19.314 27.126 20.9374 26.7653C22.575 26.4013 23.936 25.78 24.983 24.733C26.03 23.686 26.6513 22.325 27.0153 20.6874C27.376 19.064 27.5 17.0946 27.5 14.75C27.5 12.4054 27.376 10.436 27.0153 8.81259C26.6513 7.17502 26.03 5.81395 24.983 4.76697C23.936 3.72 22.575 3.09871 20.9374 2.73478C19.314 2.374 17.3446 2.25 15 2.25Z",
    fill: "url(#paint0_linear_9580_70665)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9580_70665)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3C12.6726 3 10.7681 3.12405 9.22529 3.46691C7.67676 3.81106 6.46236 4.38225 5.5473 5.2973C4.63225 6.21236 4.06106 7.42676 3.71691 8.97529C3.37405 10.5181 3.25 12.4226 3.25 14.75C3.25 17.0774 3.37405 18.9819 3.71691 20.5247L2.98478 20.6874C2.624 19.064 2.5 17.0946 2.5 14.75C2.5 12.4054 2.624 10.436 2.98478 8.81259C3.34871 7.17502 3.97 5.81395 5.01697 4.76697C6.06395 3.72 7.42502 3.09871 9.06259 2.73478C10.686 2.374 12.6554 2.25 15 2.25C17.3446 2.25 19.314 2.374 20.9374 2.73478L20.7747 3.46691C19.2319 3.12405 17.3274 3 15 3ZM26.2831 8.97533C25.9389 7.42676 25.3677 6.21236 24.4527 5.29731C23.5376 4.38225 22.3233 3.81106 20.7747 3.46691L20.9374 2.73478C22.575 3.09871 23.936 3.72 24.983 4.76697C26.03 5.81395 26.6513 7.17502 27.0153 8.81259C27.376 10.436 27.5 12.4054 27.5 14.75C27.5 17.0946 27.376 19.064 27.0153 20.6874C26.6513 22.325 26.03 23.686 24.983 24.733C23.936 25.78 22.575 26.4013 20.9374 26.7653C19.314 27.126 17.3446 27.25 15 27.25C12.6554 27.25 10.686 27.126 9.06259 26.7653C7.42502 26.4013 6.06395 25.78 5.01697 24.733C3.97 23.686 3.34871 22.325 2.98478 20.6874L3.71691 20.5247C4.06106 22.0733 4.63225 23.2876 5.54731 24.2027C6.46236 25.1177 7.67676 25.6889 9.22533 26.0331C10.7681 26.3759 12.6726 26.5 15 26.5C17.3274 26.5 19.2319 26.3759 20.7746 26.0331C22.3233 25.6889 23.5376 25.1177 24.4527 24.2027C25.3677 23.2876 25.9389 22.0733 26.2831 20.5246C26.6259 18.9819 26.75 17.0774 26.75 14.75C26.75 12.4226 26.6259 10.5181 26.2831 8.97533Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9580_70665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46946 18.75V10.0227H10.3146V17.2287H14.0561V18.75H8.46946ZM15.2781 18.75V10.0227H18.7212C19.3832 10.0227 19.9471 10.1491 20.413 10.402C20.8789 10.652 21.234 11 21.4783 11.446C21.7255 11.8892 21.8491 12.4006 21.8491 12.9801C21.8491 13.5597 21.7241 14.071 21.4741 14.5142C21.2241 14.9574 20.8619 15.3026 20.3874 15.5497C19.9158 15.7969 19.3448 15.9205 18.6744 15.9205H16.4798V14.4418H18.3761C18.7312 14.4418 19.0238 14.3807 19.2539 14.2585C19.4869 14.1335 19.6602 13.9616 19.7738 13.7429C19.8903 13.5213 19.9485 13.267 19.9485 12.9801C19.9485 12.6903 19.8903 12.4375 19.7738 12.2216C19.6602 12.0028 19.4869 11.8338 19.2539 11.7145C19.021 11.5923 18.7255 11.5312 18.3675 11.5312H17.1232V18.75H15.2781Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9580_70665",
    x: 1,
    y: 0.75,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9580_70665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9580_70665",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9580_70665",
    x: 1,
    y: 0.75,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9580_70665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9580_70665",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9580_70665",
    x: 6.6435,
    y: 10.0229,
    width: 17.0314,
    height: 12.3775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.82525
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.912623
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9580_70665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9580_70665",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9580_70665",
    x1: 15,
    y1: 2.25,
    x2: 15,
    y2: 27.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AC0A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpIcon);
export default __webpack_public_path__ + "static/media/LPIcon.652ec1024bd1ffccebbc9018c27a7f17.svg";
export { ForwardRef as ReactComponent };